import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

/**
 * The few words the sheet shell speaks on its own — today only the "Close"
 * label read out for the drag pill and the backdrop. The DS carries no i18n,
 * so the app hands them in PRE-TRANSLATED once, at its root; a sheet's own
 * `backdropAccessibilityLabel` still wins.
 */
export interface BottomSheetLabels {
  close: string;
}

const DEFAULT_LABELS: BottomSheetLabels = { close: 'Close' };

const BottomSheetLabelsContext = createContext<BottomSheetLabels>(DEFAULT_LABELS);

export function BottomSheetLabelsProvider({
  close,
  children,
}: Partial<BottomSheetLabels> & { children: ReactNode }) {
  const value = useMemo(() => ({ close: close ?? DEFAULT_LABELS.close }), [close]);
  return (
    <BottomSheetLabelsContext.Provider value={value}>
      {children}
    </BottomSheetLabelsContext.Provider>
  );
}

export function useBottomSheetLabels(): BottomSheetLabels {
  return useContext(BottomSheetLabelsContext);
}
